<template>
    <v-container style="background-color: #ffffff">
        <p style="margin: 30px 50px;">Explore your company's sustainability performance in detail under this tab. This score acts as a standard for measuring progress and ensuring 
            adherence to responsible business practices, aligning with the principles outlined in the United Nations Global Compacts for a Sustainable Business life.</p>
        <ESGscoreCsrView />
        <br/>
        <br/>
        <br/>
        <v-col cols="12">
            <h3 class="timelinetitle">Sustainability score of two consecutive years ( 2 - Year Comparison)</h3>
            <br/>
            <ESGscoretimeline />
        </v-col>
        <br/>
        <div class="flex-container">
            <h3>Click here for more comparisons</h3>
            <v-btn class="mr-10" color="primary" @click="show = !show">
                Detailed View
            </v-btn>
        </div>
        <br/>
        <v-col cols="12" v-if="show">
            <h3 class="timelinetitle">Your Sustainability Score Over the Years - (5 - Year Comparison)</h3>
            <br/>
            <ESGscoretimeline2 />
        </v-col>
    </v-container>
</template>

<script>
import ESGscoretimeline from "../components/ESGscoretimeline.vue"
import ESGscoretimeline2 from "../components/ESGscoretimeline2.vue"
import ESGscoreCsrView from "./ESGscoreCsrView.vue"
export default {
	components: { ESGscoretimeline,ESGscoretimeline2, ESGscoreCsrView },
	name: "CSR-Submission-View",
	data() {
		return {
			show: false,
		}
	},
}


</script>

<style>
.esgcontainer {
	display: flex;
	justify-content: center;
}

.scoretitle {
	display: flex;
	align-items: center;
}

.inputcommentary {
	margin: 10px;
}
.flex-container {
	display: flex;
	justify-content: center;
	align-items: center;
    gap:5%;
}
.esgtimeline {
	display: flex;
	justify-content: center;
}

.timelinetitle {
	display: flex;
	justify-content: center;
}
</style>